import React from 'react';
import { Link } from 'react-router-dom';

const S = process.env.REACT_APP_API_URL?.replace('/api','') || '';

export default function BookCard({ book }) {
  const cover = book.coverImage
    ? (book.coverImage.startsWith('http') ? book.coverImage : `${S}${book.coverImage}`)
    : null;
  const freeCount = (book.chapters||[]).filter(c=>c.isFree).length;
  const stars = Math.round(book.rating?.average || 0);

  return (
    <Link to={`/books/${book._id}`} style={{ textDecoration:'none' }}>
      <div className="card" style={{ cursor:'pointer', height:'100%', display:'flex', flexDirection:'column' }}>
        {/* Cover */}
        <div style={{ position:'relative', paddingTop:'142%', background:'var(--bg3)', flexShrink:0 }}>
          {cover ? (
            <img src={cover} alt={book.title} style={{ position:'absolute', inset:0, width:'100%', height:'100%', objectFit:'cover', transition:'transform 0.4s' }} />
          ) : (
            <div style={{ position:'absolute', inset:0, display:'flex', alignItems:'center', justifyContent:'center', background:`linear-gradient(135deg, var(--bg3), #3d2060)`, fontSize:'3rem' }}>📚</div>
          )}
          {/* Overlays */}
          <div style={{ position:'absolute', top:10, left:10 }}>
            <span className="badge badge-amber">{book.genre}</span>
          </div>
          {book.price === 0 && (
            <div style={{ position:'absolute', top:10, right:10 }}>
              <span className="badge badge-free">Free</span>
            </div>
          )}
          {book.totalReads > 0 && (
            <div style={{ position:'absolute', bottom:10, right:10, background:'rgba(0,0,0,0.65)', borderRadius:6, padding:'3px 8px', fontSize:'0.72rem', color:'var(--text2)', display:'flex', alignItems:'center', gap:4 }}>
              👁 {book.totalReads.toLocaleString()}
            </div>
          )}
        </div>

        {/* Info */}
        <div style={{ padding:'14px 14px 16px', display:'flex', flexDirection:'column', gap:6, flex:1 }}>
          <h3 style={{ fontFamily:'var(--font-d)', fontSize:'1.05rem', fontWeight:600, color:'var(--text)', lineHeight:1.3 }}>{book.title}</h3>
          <p style={{ fontSize:'0.78rem', color:'var(--text3)' }}>by {book.author||'Admin'}</p>

          {stars > 0 && (
            <div style={{ display:'flex', gap:2, alignItems:'center' }}>
              {[...Array(5)].map((_,i) => (
                <span key={i} style={{ color: i < stars ? 'var(--gold)' : 'var(--bg3)', fontSize:'0.8rem' }}>★</span>
              ))}
            </div>
          )}

          <p style={{ fontSize:'0.8rem', color:'var(--text3)', lineHeight:1.5, flex:1 }}>
            {book.description?.slice(0,80)}…
          </p>

          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', paddingTop:10, borderTop:'1px solid var(--border)', marginTop:4 }}>
            <span style={{ fontFamily:'var(--font-d)', fontSize:'1.1rem', fontWeight:700, color: book.price===0 ? 'var(--success)' : 'var(--gold)' }}>
              {book.price===0 ? 'Free' : `₹${book.price}`}
            </span>
            <span style={{ fontSize:'0.72rem', color:'var(--text3)' }}>
              {(book.chapters||[]).length} ch · {freeCount} free
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
}
